const e = (e2, t, c) => `${e2.charAt(0).toUpperCase()}${e2.slice(1)}${t.charAt(0).toUpperCase()}${t.slice(1)}${c.charAt(0).toUpperCase()}${c.slice(1)}`;
export {
  e as getDesignConfigName
};
